import EditReviewButton from "components/BookReview/EditReviewButton";
import FlagReviewButton from "components/BookReview/FlagReviewButton";
import LikeButton from "components/likes/LikeButton";
import ActivityType from "types/ActivityType";
import ActivityLink from "./ActivityLink";

export interface Props {
  activity: ActivityType;
}


export default function ActivityFooter({ activity }: Readonly<Props>) {
  return (
    <div className="space-x-2 flex items-center justify-between flex-row">
      <LikeButton likeable={activity} />

      <p className="md:hidden">
        <ActivityLink activity={activity} />
      </p>
      {!!activity.data?.userBook?.reviewSlate &&
        <div className="flex flex-row space-x-2 items-center">
          <EditReviewButton userId={activity.userId} slug={activity.book.slug} />
          <FlagReviewButton userBookId={activity?.data?.userBook?.id} />
        </div>
      }

    </div>
  );
}
